<template>
  <el-card class="calendar-panel" shadow="never">
    <div v-if="!calendar" class="empty-state">
      <i class="el-icon-calendar" style="font-size: 40px; color: #c0c4cc"></i>
      <p>暂无日历数据</p>
    </div>
    <template v-else>
      <div class="calendar-title">
        <span>{{ calendar.yearMonth }}</span>
      </div>
      <div class="week-header">
        <span v-for="item in weekDays" :key="item" class="week-cell">{{ item }}</span>
      </div>
      <div class="calendar-grid">
        <div v-for="index in emptyCells" :key="'empty-' + index" class="day-cell empty"></div>
        <button
          v-for="day in calendar.days"
          :key="day.date"
          type="button"
          :class="[
            'day-cell',
            dayClass(day.dayType),
            {
              selected: selectedDate === day.date,
              today: isToday(day.date)
            }
          ]"
          @click="$emit('select-day', day)"
        >
          <span v-if="isToday(day.date)" class="today-badge">今天</span>
          <strong>{{ day.dayOfMonth }}</strong>
          <span class="day-type">{{ dayTypeText(day.dayType) }}</span>
          <em v-if="day.dayName">{{ day.dayName }}</em>
        </button>
      </div>
    </template>
  </el-card>
</template>

<script>
export default {
  name: 'CalendarGrid',
  props: {
    calendar: {
      type: Object,
      default: null
    },
    selectedDate: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      weekDays: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
    }
  },
  computed: {
    todayDate() {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    emptyCells() {
      if (!this.calendar || !this.calendar.days || !this.calendar.days.length) return 0
      return this.calendar.days[0].weekDay - 1
    }
  },
  methods: {
    dayClass(dayType) {
      return {
        WORKDAY: 'workday',
        WEEKEND: 'weekend',
        HOLIDAY: 'holiday'
      }[dayType] || ''
    },
    isToday(date) {
      return date === this.todayDate
    },
    dayTypeText(dayType) {
      return {
        WORKDAY: '工作日',
        WEEKEND: '周末',
        HOLIDAY: '节假日'
      }[dayType] || dayType
    }
  }
}
</script>

<style scoped>
.calendar-panel {
  border: none;
  background: transparent;
}

.empty-state {
  padding: 60px 20px;
  color: var(--ink-3);
  text-align: center;
}

.empty-state p {
  margin: 12px 0 0;
  color: var(--ink-3);
}

.calendar-title {
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: 600;
  color: var(--ink);
}

.week-header,
.calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(62px, 1fr));
  gap: 8px;
}

.week-header {
  margin-bottom: 8px;
}

.week-cell {
  padding: 10px 6px;
  background: var(--surface-2);
  border-radius: var(--r-md);
  color: var(--ink-2);
  text-align: center;
  font-weight: 600;
}

.day-cell {
  position: relative;
  min-height: 92px;
  padding: 10px;
  border: 1px solid var(--line);
  border-radius: var(--r-md);
  background: var(--surface);
  box-shadow: var(--shadow-1);
  text-align: left;
  cursor: pointer;
  transition: transform .2s, border-color .2s, box-shadow .2s;
}

.day-cell.empty {
  background: transparent;
  border-color: transparent;
  box-shadow: none;
  cursor: default;
}

.day-cell:not(.empty):hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-2);
}

.day-cell.selected {
  border-color: var(--brand);
  box-shadow: 0 0 0 3px rgba(14, 145, 128, .18);
}

.day-cell.today {
  border-color: var(--brand);
  box-shadow: 0 0 0 3px rgba(14, 145, 128, .18);
}

.today-badge {
  position: absolute;
  top: 7px;
  right: 7px;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  padding: 2px 7px;
  border-radius: 999px;
  background: var(--brand);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.4;
}

.day-cell strong,
.day-cell span,
.day-cell em {
  display: block;
}

.day-cell strong {
  color: var(--ink);
  font-size: 20px;
}

.day-type {
  width: fit-content;
  margin-top: 8px;
  padding: 3px 8px;
  border-radius: 999px;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
}

.day-cell em {
  margin-top: 6px;
  color: var(--ink-2);
  font-size: 12px;
  font-style: normal;
}

/* 日类型徽章沿用语义状态色：工作日(蓝) / 周末(琥珀) / 节假日(红) */
.workday .day-type { background: var(--state-info); }
.weekend .day-type { background: var(--state-warning); }
.holiday .day-type { background: var(--state-error); }

@media (max-width: 900px) {
  .week-header,
  .calendar-grid {
    grid-template-columns: repeat(7, minmax(40px, 1fr));
    gap: 5px;
  }

  .day-cell {
    min-height: 78px;
    padding: 7px;
  }
}
</style>
